import { render, staticRenderFns } from "./AddShopSwiper.vue?vue&type=template&id=0d049482&scoped=true&"
import script from "./AddShopSwiper.vue?vue&type=script&lang=js&"
export * from "./AddShopSwiper.vue?vue&type=script&lang=js&"
import style0 from "./AddShopSwiper.vue?vue&type=style&index=0&id=0d049482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d049482",
  null
  
)

export default component.exports